export const messages = {
  nameRelation: {
    title: {
      id: 'nameRelation.Label.Title',
      defaultMessage: 'Name and Relation',
    },
    firstName: {
      id: 'nameRelation.Label.FirstName',
      defaultMessage: 'First name',
    },
    lastName: {
      id: 'nameRelation.Label.Lastname',
      defaultMessage: 'Last name',
    },
    relation: {
      id: 'nameRelation.Label.Relation',
      defaultMessage: 'Relation',
    },
    selectOne: {
      id: 'nameRelation.Label.SelectOne',
      defaultMessage: 'Select one...',
    },
    otherInformation: {
      id: 'nameRelation.Label.OtherInformation',
      defaultMessage: 'Other Information',
    },
    primaryContact: {
      id: 'nameRelation.Label.PrimaryContact',
      defaultMessage: 'Primary Contact',
    },
    nextOfKin: {
      id: 'nameRelation.Label.NextOfKin',
      defaultMessage: 'Next of Kin',
    },
    providesTransportation: {
      id: 'nameRelation.Label.ProvidesTransportation',
      defaultMessage: 'Provides transportation to appointments',
    },
  },
  isPrimaryModal: {
    title: {
      id: 'isPrimaryModal.Title',
      defaultMessage: 'Only one Primary Contact is allowed.',
    },
    message: {
      id: 'isPrimaryModal.Label.Message',
      defaultMessage: 'Do you want to change the Primary Contact?',
    },
    submitBtnText: {
      id: 'isPrimaryModal.Button.Submit',
      defaultMessage: 'Yes',
    },
    hideBtnText: {
      id: 'isPrimaryModal.Button.Cancel',
      defaultMessage: 'Cancel',
    },
  },
};
